export default __webpack_public_path__ + "static/media/fa.d.ts.8383a952.map";